import { INewStoryContent, IStory, IStoryContent } from '@opengov/stories-shared/types';
import React from 'react';

import { IModalMessages, ISettings } from '../../../types';
import { Modal } from '../Modal';

import styles from './AddContent.scss';

export interface IAddContentProps {
  isTemplate: boolean;
  entityId: number;
  entitySubdomain: string;
  story: IStory;
  entityName: string;
  settings: ISettings;
  userId: string;
  storyContents: IStoryContent[];
  order: number;
  groups: string[];
  newStoryContents: INewStoryContent[];
  messages: IModalMessages;
  onClose(): void;
  createStoryContent(props: {
    isTemplate: boolean;
    entityId: number;
    entityName: string;
    entitySubdomain: string;
    story: IStory;
    userId: string;
    settings: ISettings;
    storyContent: INewStoryContent;
    storyContents?: IStoryContent[];
    order?: number;
  }): Promise<void>;
}

export const handleClick = ({
  isTemplate,
  entityId,
  entitySubdomain,
  story,
  order,
  storyContent,
  storyContents,
  settings,
  onClose,
  userId,
  createStoryContent
}) => {
  void onClose();
  void createStoryContent({
    isTemplate,
    entityId,
    userId,
    entitySubdomain,
    story,
    order,
    storyContent,
    storyContents,
    settings
  });
};

export const AddContent: React.FC<IAddContentProps> = ({
  isTemplate,
  entityId,
  entitySubdomain,
  story,
  storyContents,
  order,
  groups,
  newStoryContents,
  userId,
  messages,
  onClose,
  createStoryContent,
  settings
}) => {
  return (
    <Modal title={messages.addContent} onClose={onClose}>
      {groups.map((group, idx) => (
        <div className={styles.row} key={`row-${idx}`}>
          <h2 className={styles.heading}>{group}</h2>
          {newStoryContents
            .filter((storyContent) => storyContent.group === group)
            .map((storyContent, i) => (
              <img
                className={styles.thumbnail}
                key={`thumbnail-${i}`}
                src={storyContent.thumbnail}
                alt={storyContent.description}
                data-test="story-section-thumbnail"
                onClick={() =>
                  handleClick({
                    isTemplate,
                    entityId,
                    entitySubdomain,
                    story,
                    userId,
                    order,
                    storyContent,
                    storyContents,
                    settings,
                    onClose,
                    createStoryContent
                  })
                }
              />
            ))}
        </div>
      ))}
    </Modal>
  );
};
